import { connect } from 'react-redux';

import AssetProvider from './AssetProvider';

export function mapStateToProps(state) {
  return { highlightAssets: state.assets.highlightAssets };
}

export default connect(mapStateToProps)(AssetProvider);
